import { render, staticRenderFns } from "./VariantButton.vue?vue&type=template&id=32b0e3a1&scoped=true&"
import script from "./VariantButton.vue?vue&type=script&lang=js&"
export * from "./VariantButton.vue?vue&type=script&lang=js&"
import style0 from "./VariantButton.vue?vue&type=style&index=0&id=32b0e3a1&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b0e3a1",
  null
  
)

export default component.exports